import React from 'react';
import { GraduationCap } from 'lucide-react';

import './Education.css';
import { theme } from '../../theme/designSystem';
import { educationData } from '../../data/educationData';

function Education() {
    // Only show higher education (first 2 entries)
    const relevantEducation = educationData.slice(0, 2);

    return (
        <section className="education" id="education" style={{ backgroundColor: theme.tertiary }}>
            <div className="education--container">
                <span className="eyebrow eyebrow--center">Education</span>
                <h2 style={{ color: theme.primary }}>Academic foundation</h2>

                <div className="education--list">
                    {relevantEducation.map((edu, index) => (
                        <div
                            key={edu.id}
                            className="education--card fade-in-up"
                            style={{
                                backgroundColor: theme.cardBg,
                                borderColor: theme.border,
                                animationDelay: `${index * 0.1}s`
                            }}
                        >
                            <div className="education--icon" style={{ backgroundColor: theme.accent }}>
                                <GraduationCap size={20} color="#FFF" />
                            </div>
                            <div className="education--content">
                                <span className="education--dates" style={{ color: theme.accent }}>
                                                                    {edu.startYear} to {edu.endYear}
                                                                </span>
                                <h3 style={{ color: theme.primary }}>{edu.course}</h3>
                                <p style={{ color: theme.textSecondary }}>{edu.institution}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Education;
